<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="documents__background module__background"
        ></app-modulebackground>
        <div
            class="documents__container module__container"
            v-bind:class="{
                container__fluid: [5, 6].includes(module.layout.type),
                container__boxed: [1, 2, 3, 4].includes(module.layout.type)
            }"
        >
            <div class="documents__inner module__inner">
                <div
                    class="documents__inner--main module__inner--main"
                    v-bind:class="{
                        'calc-padding--left': [5].includes(module.layout.type),
                        'calc-padding--right': [6].includes(module.layout.type)
                    }"
                >
                    <div
                        class="documents__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="documents__inner-col module__inner-col">
                            <div class="documents__header module__header">
                                <h2
                                    class="documents__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="documents__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="documents__inner-row module__inner-row">
                        <div class="documents__inner-col module__inner-col">
                            <div class="documents__content-block module__content-block">
                                <div
                                    class="documents__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="documents__inner-row module__inner-row">
                                        <div class="documents__inner-col module__inner-col">
                                            <div
                                                class="documents__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="documents__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="documents__inner-row module__inner-row">
                                        <div class="documents__inner-col module__inner-col">
                                            <div class="documents__list module__list">
                                                <div
                                                    v-for="items__value in items"
                                                    v-bind:key="items__value.id"
                                                    :data-preset-id="items__value.preset_id"
                                                    class="documents__list-item module__list-item"
                                                    v-bind:class="{
                                                        'col__width--half': [1, 2].includes(
                                                            module.layout.type
                                                        ),
                                                        'col__width--full': [3, 4, 5, 6].includes(
                                                            module.layout.type
                                                        )
                                                    }"
                                                >
                                                    <a
                                                        v-bind:href="
                                                            generateMediaUrl({
                                                                id: items__value.data.file.id
                                                            })
                                                        "
                                                        target="_blank"
                                                        class="documents__teaser-box"
                                                        v-bind:class="{
                                                            'module__teaser-box--vertical': [
                                                                1,
                                                                2,
                                                                3,
                                                                4,
                                                                5,
                                                                6
                                                            ].includes(module.layout.type)
                                                        }"
                                                        v-if="
                                                            items__value.data &&
                                                                items__value.data.name &&
                                                                items__value.data.file
                                                        "
                                                    >
                                                        <app-moduleicon
                                                            v-if="
                                                                [1, 2, 5, 6].includes(
                                                                    module.layout.type
                                                                )
                                                            "
                                                            :data="{
                                                                id: getRandomImageInNamespace(
                                                                    'icons/documents/default'
                                                                )
                                                            }"
                                                            :custom-class="
                                                                'documents__list-item-icon module__icon'
                                                            "
                                                        ></app-moduleicon>
                                                        <div
                                                            class="documents__teaser-box-text module__teaser-box-text"
                                                        >
                                                            <div
                                                                class="documents__list-item-title module__link font-bold module__link--underlined"
                                                            >
                                                                {{ items__value.data.name }}
                                                            </div>
                                                            <div
                                                                v-if="
                                                                    items__value.data &&
                                                                        items__value.data.text
                                                                "
                                                                class="documents__list-item-desc"
                                                            >
                                                                {{ items__value.data.text }}
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="documents__inner-row module__inner-row"
                        v-if="
                            (module.data.link && module.data.link.active) ||
                                (module.data.link2 && module.data.link2.active) ||
                                (module.data.link3 && module.data.link3.active)
                        "
                    >
                        <div class="documents__inner-col module__inner-col">
                            <div class="documents__cta module__cta">
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'documents__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link2"
                                    :custom-class="
                                        'documents__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link3"
                                    :custom-class="
                                        'documents__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="documents__inner--image module__inner--image"
                    v-if="
                        [5, 6].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[5, 6].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'documents__moduleimage module__moduleimage'"
                    ></app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-moduleicon': ModuleIcon,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['generateMediaUrl', 'getRandomImageInNamespace']),
        items() {
            return toArray(this.module.data.documents)
                .filter((i) => i.visible)
                .sort((a, b) => a.pos - b.pos);
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
